import { Link } from "react-router-dom";
import { Brand } from "@/components/Brand";
import { SiteFooter } from "@/components/SiteFooter";

function Block({ title, children }) {
    return (
        <section className="mt-10">
            <h2 className="text-[20px] font-bold tracking-tight text-ink">{title}</h2>
            <div className="mt-3 space-y-3 measure text-[16px] leading-[1.6] text-subtle">{children}</div>
        </section>
    );
}

export default function Legal() {
    return (
        <div className="min-h-screen bg-background">
            <header className="border-b border-line bg-background">
                <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-4">
                    <Brand />
                    <Link to="/" className="text-[14px] text-subtle hover:text-ink">Volver al inicio</Link>
                </div>
            </header>

            <main className="mx-auto max-w-3xl px-6 py-16">
                <h1 className="text-[34px] font-bold leading-[1.1] tracking-[-0.02em] text-ink lg:text-[44px]">
                    Aviso legal y condiciones
                </h1>

                <Block title="Titular del servicio">
                    <p>
                        Este sitio y el servicio MYAVEREN son operados por <strong className="text-ink">Olga García Estévez</strong>,
                        con DNI 08035475B y domicilio en Calle Polvoranca 70, escalera 2, 8C, 28923 Alcorcón (Madrid).
                        Contacto: <a href="mailto:garciaestevezolga@gmail.com" className="text-terracotta hover:underline">garciaestevezolga@gmail.com</a>.
                    </p>
                </Block>

                <Block title="Objeto del servicio">
                    <p>
                        MYAVEREN es una herramienta de <strong className="text-ink">asesoría cosmética independiente</strong>: analiza
                        tus respuestas y los productos que indicas y te devuelve una lectura de tu rutina. No vendemos productos
                        y no ofrecemos consejo médico ni diagnóstico. Ante cualquier problema de piel que te preocupe, consulta con
                        un profesional sanitario.
                    </p>
                </Block>

                <Block title="Planes y precios">
                    <p>
                        El plan <strong className="text-ink">Esencial</strong> es gratuito. El plan <strong className="text-ink">Completo</strong> tiene
                        un precio de <strong className="text-ink">19,90 €</strong> en un <strong className="text-ink">pago único</strong> (IVA incluido),
                        que desbloquea el análisis completo y el informe para esa revisión. No es una suscripción: no hay cobros recurrentes.
                    </p>
                </Block>

                <Block title="Pago">
                    <p>
                        El pago se realiza de forma segura a través de nuestro proveedor de pagos. Al completar la compra desbloqueas
                        de inmediato tu análisis completo y tu informe en PDF.
                    </p>
                </Block>

                <Block title="Derecho de desistimiento">
                    <p>
                        Al tratarse de un contenido digital que se ejecuta y entrega de forma inmediata tras el pago, al confirmar la
                        compra solicitas su ejecución inmediata y aceptas que, una vez desbloqueado el contenido, decae el derecho de
                        desistimiento conforme a la normativa de consumo. Si algo no funciona como esperabas, escríbenos y lo resolvemos.
                    </p>
                </Block>

                <Block title="Responsabilidad">
                    <p>
                        Las recomendaciones de MYAVEREN son orientativas y la decisión final siempre es tuya. No nos hacemos responsables
                        del uso que hagas de los productos ni de reacciones individuales. Revisa siempre el etiquetado y, si tienes dudas,
                        consulta con un profesional.
                    </p>
                </Block>

                <Block title="Tus datos">
                    <p>
                        El tratamiento de tus datos personales se rige por nuestra{" "}
                        <Link to="/privacidad" className="text-terracotta hover:underline">política de privacidad</Link>.
                    </p>
                </Block>
            </main>

            <SiteFooter />
        </div>
    );
}
